export default "__VITE_ASSET__DNxC4UJe__"